import { render, staticRenderFns } from "./ExampleLoader.vue?vue&type=template&id=65092141&"
import script from "./ExampleLoader.vue?vue&type=script&lang=js&"
export * from "./ExampleLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports